export const MAIN_GREEN = '#42C67E';
export const SUB_TEXT = '#5F5F5F';
export const SUB_TITLE = '#8E8E8E';
export const SUB_LINE = '#ECECEC';
export const MAIN_TEXT = '#282828';
export const WARN_RED = '#FF4D4F';

//css
export const SHADOW_MAIN = '0px 0px 10px 0px rgba(0, 0, 0, 0.05)';
